import { useMutation } from '@tanstack/react-query';

import { updateEmail } from '../../../api/account';

export function useUpdateEmail() {
  return useMutation({ mutationFn: updateEmail });
}
